/**
 * Created by Omar Alejandro Leonor Avalos on 2017-07-22.
 */
import React, { Component } from 'react';
import WhatShot from 'material-ui/svg-icons/social/whatshot';
import CorreoElectronico from 'material-ui/svg-icons/communication/email';
import Calle from 'material-ui/svg-icons/maps/streetview';
import { Toggle } from 'material-ui';
import Filter from './filter';
import { EditableInline } from '../../components/text';
import Container from './container';
import { TextField } from 'material-ui';

const filter = {
    name: '',
    email:'',
    active: true
};

class FilterContainer extends Component {
    constructor(props) {
        super(props);
        this.state = { ...filter};
    }

    updateValue = (path, value) => {
        this.setState({ [path]: value });
    };

    handleToggle() {
        this.updateValue('active', !this.state.active)
    }

    render() {
      const { children, onSearch, onClear } = this.props;
      const {name, email, active } = this.state;

        return (
            <Container
                contents={children}
                onSearch={() => onSearch(this.state)}
                onClear={() => {
                  this.setState({ ...filter })
                  onClear(this.state);
                }}
            >
                <Filter icon={<WhatShot />} title="Nombre Usuario" id="nombrecompleto">
                    <TextField
                        hintText="Nombre Usuario..."
                        fullWidth
                        value={name}
                        onChange={(event, value) => this.updateValue('name', value)}
                    />
                </Filter>
                <Filter icon={<CorreoElectronico />} title="Correo Electronico" id="correoelectronico">
                    <TextField
                        hintText="Correo Electronico..."
                        fullWidth
                        value={email}
                        onChange={(event, value) => this.updateValue('email', value)}
                    />
                </Filter>
                <Filter icon={<Calle />} title="Activo" id="activo">
                    <Toggle label={active === true ?  "Activo":"Inactivo"}
                      defaultToggled={active}
                      onToggle={this.handleToggle.bind(this)}
                    />
                </Filter>
            </Container>
        );
    }
}

export default FilterContainer;



// WEBPACK FOOTER //
// ./components/filters/usuarios.js